module.exports = __webpack_public_path__ + "img/big-icons-sprite.07296138.svg";